import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled, { css } from 'styled-components';
const StyledImage = styled.img `
  width: 100%;
  ${({ rounded, theme }) => rounded && `border-radius: ${theme.Border.Radius.Medium}px;`}

  ${({ theme, isLoaded }) => css `
    opacity: ${isLoaded ? 1 : 0};
    transition: opacity ${theme.Transition.Timing.Out};
  `}
`;
export const Image = React.forwardRef(function Image(props, ref) {
    const { alt, rounded, onLoad, className, onError } = props;
    const [isLoaded, setIsLoaded] = useState(false);
    const [activeSource, setActiveSource] = useState(0);
    useEffect(() => {
        setActiveSource(0);
    }, [props.source]);
    const sourceList = useMemo(() => {
        const temp = Array.isArray(props.source)
            ? [...props.source]
            : [props.source];
        if (props.sourceFallback) {
            temp.push(props.sourceFallback);
        }
        return temp;
    }, [props.source, props.sourceFallback]);
    const source = sourceList[activeSource];
    const handleLoadSuccess = useCallback((event) => {
        setIsLoaded(true);
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(event, source);
    }, [onLoad, source]);
    const handleLoadError = useCallback((event) => {
        if (activeSource < sourceList.length - 1) {
            setActiveSource((prev) => prev + 1);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(event);
        }
    }, [activeSource, sourceList, onError]);
    if (!source)
        return null;
    return (_jsx(StyledImage, { ref: ref, id: props.id, className: className, src: source, alt: alt, isLoaded: isLoaded, rounded: rounded, draggable: props.draggable, onLoad: handleLoadSuccess, onError: handleLoadError, height: props.height }));
});
//# sourceMappingURL=Image.js.map